import { withInstall } from '@hd-front-end/utils'
import Affix from './src/affix.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElAffix: SFCWithInstall<typeof Affix> = withInstall(Affix)
export default ElAffix

export * from './src/affix'
